<template>
  <div class="page-wrapper">
    <AppHeader title="Promotions" />
    <div class="container-fluid">
    <div class="container-fluid">
      <div class="row topnav" style="padding-left: 15px">
        <!-- <div class="col-sm-1">
          <div
            class="dropdown"
            style="
              position: fixed;
              left: 0;
              top: 0;
              padding: 0;
              margin-top: 0;
              margin-bottom: 0;
            "
          >
            <MainMenu />
          </div>
        </div> -->
        <div class="col-sm-12">
          <div v-show="showError" style="text-align: center">
            <label class="h3" style="color: maroon">
              {{ this.mainErrorMsg }}
            </label>
          </div>
        </div>
      </div>
      <div v-if="showAddPromotion" style="width: 100%; display: flex; justify-content: center;">
        <div class="card shadow-lg" style="background-color: var(--form-color); padding: 30px; border-radius: 15px; width: 100%; max-width: 800px; color: var(--theme-text-main);">
          <div class="form-group mb-3">
            <label title="promoition_name" style="font-size: 1.2em; display: block; margin-bottom: 5px;">Promotion Name</label>
            <input
              type="text"
              v-model="promoition_name"
              class="form-control input-lg"
              :class="{ 'is-invalid': submitted && !promoition_name }"
              style="font-size: 1.2em; background: rgba(0,0,0,0.2); border: 1px solid rgba(255,255,255,0.1); color: var(--theme-text-main);"
            />
            <div v-if="submitted && !promoition_name" class="text-danger mt-1">
                 Promotion name is required
            </div>
          </div>

          <div class="row" style="margin-bottom: 20px;">
            <div class="col-md-6 mb-3">
              <label title="start_date" style="font-size: 1.2em; display: block; margin-bottom: 5px;">Start Date</label>
              <div style="display: block;">
                <datepicker
                  v-model="state.start_date"
                  name="selected_date"
                  format="yyyy-MM-dd"
                  @selected="parentfunctionSelectedhandler"
                  @opened="datepickerOpenedFunction"
                  @closed="parentfunctionCloseHandler"
                  input-class="form-control input-lg"
                  style="font-size: 1.2em;"
                ></datepicker>
              </div>
            </div>
            <div class="col-md-6 mb-3">
              <label title="end_date" style="font-size: 1.2em; display: block; margin-bottom: 5px;">End Date</label>
              <div style="display: block;">
                <datepicker
                  v-model="stateEnd.end_date"
                  name="selected_date"
                  format="yyyy-MM-dd"
                  @selected="parentfunctionSelectedhandler"
                  @opened="datepickerOpenedFunction"
                  @closed="parentfunctionCloseHandler"
                  input-class="form-control input-lg"
                  style="font-size: 1.2em;"
                ></datepicker>
              </div>
            </div>
          </div>

          <div class="row" style="margin-bottom: 30px;">
            <div class="col-md-6 mb-3">
              <label title="minimum_total" style="font-size: 1.2em; display: block; margin-bottom: 5px;">Minimum Total</label>
              <input
                type="text"
                v-model="minimum_total"
                class="form-control input-lg"
                style="font-size: 1.2em; background: rgba(0,0,0,0.2); border: 1px solid rgba(255,255,255,0.1); color: var(--theme-text-main);"
              />
            </div>
            <div class="col-md-6 mb-3">
              <label title="percentage" style="font-size: 1.2em; display: block; margin-bottom: 5px;">Percentage</label>
              <input
                type="text"
                v-model="percentage"
                class="form-control input-lg"
                style="font-size: 1.2em; background: rgba(0,0,0,0.2); border: 1px solid rgba(255,255,255,0.1); color: var(--theme-text-main);"
              />
            </div>
          </div>

          <div v-if="promotionId === -1">
            <div class="row" style="margin-bottom: 30px;">
              <div class="col-md-12">
                <div
                  class="permission-card"
                  :class="{ active: useExcel }"
                  @click="useExcel = !useExcel"
                  style="max-width: 320px;"
                >
                  <div class="custom-checkbox">
                    <i class="fa fa-check checkmark"></i>
                  </div>
                  <span>Use Excel</span>
                </div>
              </div>
            </div>

            <div v-if="useExcel" class="row" style="margin-bottom: 30px;">
              <div class="col-md-12">
                <button
                  type="button"
                  class="btn btn-info"
                  @click="downloadTemplate"
                  style="margin-right: 10px; font-size: 1.1em;"
                >
                  Download Template
                </button>
                <button
                  type="button"
                  class="btn btn-primary"
                  @click="triggerFileUpload"
                  style="font-size: 1.1em;"
                >
                  Upload Excel
                </button>
                <input
                  type="file"
                  ref="fileInput"
                  @change="handleFileUpload"
                  style="display: none"
                  accept=".xlsx, .xls"
                />
                <span
                  v-if="excelItems.length > 0"
                  style="margin-left: 10px; font-size: 1.1em; color: var(--theme-text-main);"
                  >{{ excelItems.length }} items loaded</span>
              </div>
            </div>
          </div>

          <div
            v-if="promotionId !== -1 && existingExcelUrl"
            class="row"
            style="margin-bottom: 30px;"
          >
            <div class="col-md-12">
              <div style="display:flex;align-items:center;gap:10px;flex-wrap:wrap;">
                <span style="font-size: 1.1em;">Excel File:</span>
                <a
                  class="btn btn-success"
                  :href="existingExcelUrl"
                  target="_blank"
                  rel="noopener"
                  :download="existingExcelName || undefined"
                >
                  Download
                </a>
                <span v-if="existingExcelInfo" style="font-size: 0.95em; opacity: 0.9;">
                  {{ existingExcelInfo }}
                </span>
              </div>
            </div>
          </div>

          <div style="text-align: right; margin-top: 20px; border-top: 1px solid rgba(255,255,255,0.1); padding-top: 20px;">
            <button
              class="btn btn-danger btn-lg"
              style="font-size: 1.2em; margin-right: 10px;"
              @click="cancelSavePromotion"
            >
              Cancel
            </button>
            <button
              class="btn btn-success btn-lg"
              v-if="promotionId === -1"
              style="font-size: 1.2em;"
              @click="createPromotion"
            >
              Save
            </button>
            <button
              class="btn btn-success btn-lg"
              v-if="promotionId !== -1"
              style="font-size: 1.2em;"
              @click="updatePromotion"
            >
              Update
            </button>
          </div>
        </div>
      </div>
      <div v-if="toggle">

        
      <div class="touch-search-header">
        <div class="touch-search-area">
          <div class="input-group touch-search-group">
            <span class="input-group-addon">
              <i class="glyphicon glyphicon-search"></i>
            </span>
            <input
              type="text"
              v-model="searchPromotion"
              class="form-control input-lg"
              placeholder="Search promotions"
              @keyup.enter="applyPromotionSearch()"
            />
            <span class="input-group-btn">
              <button class="btn btn-success btn-lg" @click="applyPromotionSearch()">
                Search
              </button>
            </span>
          </div>
        </div>
        <div class="touch-search-actions">
          <button
            v-if="hasPermission(42)"
            class="btn btn-success btn-lg"
            @click="handleAddPromotion"
          >
            New Promotion
          </button>
        </div>
      </div>
        <br />
        <br>
        <div
          v-if="toggle"
          class="row table-wrap"
          style="color: #fff; "
        >
          <table class="table" style="color: #fff">
            <thead>
              <tr>
                
                <th style="font-size: 1.1em">Promotion Name</th>
                <th style="font-size: 1.1em">Start Date</th>
                <th style="font-size: 1.1em">End Date</th>
                <th style="font-size: 1.1em">Minimum Total</th>
                <th style="font-size: 1.1em">Percentage</th>
                <!-- <th style="font-size: 1.5em"></th>
                <th style="font-size: 1.5em"></th> -->
                <th style="font-size: 1.1em"></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="promotion in filteredPromotions" :key="promotion.id">

                <td style="font-size: 1.2em">
                  {{ promotion.promoition_name }}
                </td>
                <td style="font-size: 1em">{{ promotion.start_date }}</td>
                <td style="font-size: 1em">{{ promotion.end_date }}</td>
                <td style="font-size: 1em">{{ promotion.minimum_total }}</td>
                <td style="font-size: 1em">{{ promotion.percentage }}</td>
                                <td>
                  <button
                    v-if="hasPermission(43)"
                    class="btn btn-success"
                    style="font-size: 1em"
                    @click="editPromotion(promotion.id)"
                  >
                    Edit
                  </button>
                </td>
                <!-- <td></td>
                <td></td> -->
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import axios from "axios";
import commonServices from "@/shared/commonServices";
import AppHeader from "@/components/AppHeader";
import MainMenu from "@/components/MainMenu";
import Datepicker from "vuejs3-datepicker";
import "vue-date-pick/dist/vueDatePick.css";
import * as XLSX from "xlsx";

export default {
  computed: {
    filteredPromotions() {
      let list = this.allPromotions || [];
      const search = (this.searchPromotion || "").toLowerCase();

      if (search) {
        list = list.filter((p) => {
          const name = (p.promoition_name || "").toLowerCase();
          const start = (p.start_date || "").toLowerCase();
          const end = (p.end_date || "").toLowerCase();
          const min = (p.minimum_total || "").toString().toLowerCase();
          const perc = (p.percentage || "").toString().toLowerCase();
          return (
            name.includes(search) ||
            start.includes(search) ||
            end.includes(search) ||
            min.includes(search) ||
            perc.includes(search)
          );
        });
      }

      return list;
    },
  },
  mixins: [commonServices],
  mounted() {
    const nowDate = new Date();

    let year = nowDate.getFullYear();
    let month = nowDate.getMonth();
    let day = nowDate.getDate();
    this.state.start_date = new Date(year + "", month + "", day + "");
    this.stateEnd.end_date = new Date(year + "", month + "", day + "");

    this.getActivePromotions();
    this.getAllPromotions();
    if (localStorage.userId !== undefined && localStorage.appId !== undefined) {
      // console.log(localStorage.userId!==undefined && localStorage.appId !== undefined)
    } else {
      // this.$router.push({ name: 'login'});
    }
    this.language = "ar";

    this.logoImage =
      '<img src="' + this.logoUrl + '" width="70" height="50" alt="Logo">';
  },
  components: { MainMenu, Datepicker, AppHeader },
  data: function () {
    return {
      state: { start_date: new Date(2016, 9, 16) },
      stateEnd: { end_date: new Date(2016, 9, 16) },
      showAddPromotion: false,
      promotions: [],
      allPromotions: [],
      searchPromotion: "",

      promotionJson: {},
      promotionInfos: {},
      promotionId: -1,
      useExcel: false,
      excelFile: null,
      excelFileName: "",
      existingExcelUrl: "",
      existingExcelName: "",
      existingExcelInfo: "",
      excelItems: [],
      promoition_name: "",
      submitted: false,
      start_date: "",
      end_date: "",
      minimum_total: "",
      percentage: "",

      reports_ok: false,
      showError: false,
      logoImage: "",
      mainErrorMsg: "",
      logoUrl: "",
      jsonData: {},
      language: "en",
      languageName: "",
      toggle: true,
      showInvoices: false,
      showPayments: false,
      addresses: [],
      selectedcustomers: [],
      customer_invoices: [],
      customer_payments: [],
      customersJson: {},
      name: "",
      gender: "",
      email: "",
      phone: "",
      totalpoints: "",
      dis_percentage: "",
      status: "",
      creditstatus: "",
      date_added: "",
      aaddressid: 0,
      addressLine1: "",
      addressLine2: "",
      addressArea: "",
      addressCity: "",
      isDefault: false,
      customerAddresses: [],
      showAddress: false,
      findcustomer: "",
      findcustomername: "",
      customeraddress: {},
    };
  },
  methods: {
    applyPromotionSearch() {
      this.searchPromotion = (this.searchPromotion || "").trim();
    },
    editPromotion(promotionId) {
      this.getPromotion(promotionId);
    },

    getPromotion: async function (id) {
      this.promotionJson.appId = localStorage.appId;
      this.promotionJson.promotionId = id;
      this.useExcel = false;
      this.excelItems = [];
      this.existingExcelUrl = "";
      this.existingExcelName = "";
      this.existingExcelInfo = "";
      let promotionJson_ = JSON.stringify(this.promotionJson);
      try {
        let dataURL = this.apiURL + "Promotion/getPromotion";

        let response = await axios.post(dataURL, promotionJson_);
        if (response.data.status === "success") {
          this.promotionInfos = response.data.results.promotion[0];
          this.getAllPromotions();
          this.promotionId = this.promotionInfos.id;
          this.promoition_name = this.promotionInfos.promoition_name;
          this.state.start_date = this.promotionInfos.start_date;
          this.stateEnd.end_date = this.promotionInfos.end_date;
          this.minimum_total = this.promotionInfos.minimum_total;
          this.percentage = this.promotionInfos.percentage;
          this.existingExcelName = this.promotionInfos.excel_file_name || "";
          this.existingExcelUrl = this.getExcelPublicUrl(
            this.promotionInfos.excel_file_path
          );
          this.existingExcelInfo = this.buildExcelInfo(this.promotionInfos);
          this.toggle = false;
          this.showAddPromotion = true;
        }
      } catch (error) {
        console.log(error);
      }
    },
    getExcelPublicUrl(filePath) {
      if (!filePath) return "";
      const path = String(filePath).replace(/\\/g, "/");
      const marker = "/viaPos/";
      const idx = path.indexOf(marker);
      if (idx >= 0) {
        const afterViaPos = path.slice(idx + "/viaPos".length);
        return `${this.baseUrl}${afterViaPos}`;
      }
      if (path.startsWith("/uploads/")) {
        return `${this.baseUrl}${path}`;
      }
      return "";
    },
    buildExcelInfo(promotionInfos) {
      if (!promotionInfos || promotionInfos.file_exists != 1) return "";
      const parts = [];
      if (promotionInfos.excel_file_name) parts.push(promotionInfos.excel_file_name);
      const size = Number(promotionInfos.file_size);
      if (!Number.isNaN(size) && size > 0) {
        const kb = Math.round(size / 1024);
        parts.push(`${kb} KB`);
      }
      if (promotionInfos.file_modified) parts.push(promotionInfos.file_modified);
      return parts.join(" • ");
    },
    downloadTemplate() {
      const ws = XLSX.utils.json_to_sheet([
        { "Item Code / Barcode": "", "New Price": "" },
      ]);

      
      ws['!cols'] = [
          { width: 30 }, // عرض العمود الأول
          { width: 20 }  // عرض العمود الثاني
      ];

        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Template");
        XLSX.writeFile(wb, "PromotionTemplate.xlsx");

      },
      
    triggerFileUpload() {
      this.$refs.fileInput.click();
    },
    handleFileUpload(event) {
      const file = event.target.files[0];
      if (!file) return;

      this.excelFile = file;
      this.excelFileName = file.name || "";

      const reader = new FileReader();
      reader.onload = (e) => {
        const data = new Uint8Array(e.target.result);
        const workbook = XLSX.read(data, { type: "array" });
        const firstSheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[firstSheetName];
        const jsonData = XLSX.utils.sheet_to_json(worksheet);

        this.excelItems = jsonData
          .map((row) => ({
            item_code:
              row["Item Code / Barcode"] || row["Item Code"] || row["Barcode"],
            new_price: row["New Price"],
          }))
          .filter((item) => item.item_code && item.new_price !== undefined);

        this.showSuccess(`Loaded ${this.excelItems.length} items from Excel.`);
      };
      reader.readAsArrayBuffer(file);
    },
    exportInsertedErrorRecords(records) {
      const safeRecords = Array.isArray(records) ? records : [];
      if (safeRecords.length === 0) return;

      const normalized = safeRecords.map((r) => ({
        item_code: r?.item_code ?? "",
        new_price: r?.new_price ?? "",
        reason: r?.reason ?? "",
      }));

      const ws = XLSX.utils.json_to_sheet(normalized);
      ws["!cols"] = [{ width: 24 }, { width: 16 }, { width: 60 }];
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Errors");
      XLSX.writeFile(wb, "PromotionErrors.xlsx");
    },
    normalizePromotionDate(value) {
      if (!value) return "";
      if (value instanceof Date) {
        if (!Number.isNaN(value.getTime())) return value.toISOString();
        return "";
      }
      if (typeof value === "string") {
        const m = value.match(/^(\d{4})-(\d{2})-(\d{2})$/);
        if (m) {
          const d = new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3]));
          if (!Number.isNaN(d.getTime())) return d.toISOString();
          return value;
        }
      }
      const d = new Date(value);
      if (!Number.isNaN(d.getTime())) return d.toISOString();
      return String(value);
    },
    buildPromotionFormData(promotionJson) {
      const formData = new FormData();

      const fields = {
        appId: promotionJson?.appId ?? "",
        promoition_name: promotionJson?.promoition_name ?? "",
        start_date: this.normalizePromotionDate(promotionJson?.start_date),
        end_date: this.normalizePromotionDate(promotionJson?.end_date),
        minimum_total: promotionJson?.minimum_total ?? "",
        percentage: promotionJson?.percentage ?? "",
        useExcel: promotionJson?.useExcel ? "true" : "false",
      };

      Object.entries(fields).forEach(([key, value]) => {
        formData.append(key, value);
      });

      const items = Array.isArray(promotionJson?.items) ? promotionJson.items : [];
      items.forEach((item, index) => {
        formData.append(`items[${index}][item_code]`, item?.item_code ?? "");
        formData.append(`items[${index}][new_price]`, item?.new_price ?? "");
      });

      return formData;
    },
    createPromotion: async function () {
      this.promotionJson.appId = localStorage.appId;
      this.promotionJson.promoition_name = this.promoition_name;
      this.promotionJson.start_date = this.normalizePromotionDate(this.state.start_date);
      this.promotionJson.end_date = this.normalizePromotionDate(this.stateEnd.end_date);
      this.promotionJson.minimum_total = this.minimum_total;
      this.promotionJson.percentage = this.percentage;
       this.submitted = true
    if (!this.promoition_name) {
      return
    }
      if (this.useExcel) {
        this.promotionJson.useExcel = true;
        this.promotionJson.items = this.excelItems;
      }
      if (this.promotions.length > 0) {
        this.showAlert("You can not add tow active promotions!");
      } else {
        try {
          let dataURL = this.apiURL + "Promotion/createPromotion";
          let response;

          if (this.useExcel && this.excelFile) {
            const formData = this.buildPromotionFormData(this.promotionJson);
            formData.append(
              "file",
              this.excelFile,
              this.excelFileName || this.excelFile.name
            );
            response = await axios.post(dataURL, formData, {
              headers: { "Content-Type": "multipart/form-data" },
            });
          } else {
            response = await axios.post(dataURL, this.promotionJson);
          }

          if (
            response?.data?.inserted_error_records &&
            Array.isArray(response.data.inserted_error_records) &&
            response.data.inserted_error_records.length > 0
          ) {
            this.exportInsertedErrorRecords(response.data.inserted_error_records);
            this.showAlert("Some rows failed. PromotionErrors.xlsx was downloaded.");
          }

          if (response.data.status === "success") {
            this.showSuccess("Promotion Added Successfully!");
            this.getAllPromotions();
            this.handleAddPromotion();
            this.cancelSavePromotion();
          } else {
            if (
              !response?.data?.inserted_error_records ||
              !Array.isArray(response.data.inserted_error_records) ||
              response.data.inserted_error_records.length === 0
            ) {
              this.showAlert("Error Happened Please Check Entered Data!");
            }
          }
        } catch (error) {
          console.log(error);
        }
      }
    },
    cancelSavePromotion() {
      this.toggle = true;
      this.showAddPromotion = false;
      this.excelFile = null;
      this.excelFileName = "";
      this.excelItems = [];
      this.existingExcelUrl = "";
      this.existingExcelName = "";
      this.existingExcelInfo = "";
      try {
        if (this.$refs.fileInput) this.$refs.fileInput.value = "";
      } catch (e) {}
    },

    updatePromotion: async function () {
      this.promotionJson.appId = localStorage.appId;
      this.promotionJson.promotionId = this.promotionId;
      this.promotionJson.promoition_name = this.promoition_name;
      this.promotionJson.start_date = this.normalizePromotionDate(this.state.start_date);
      this.promotionJson.end_date = this.normalizePromotionDate(this.stateEnd.end_date);
      this.promotionJson.minimum_total = this.minimum_total;
      this.promotionJson.percentage = this.percentage;
       this.submitted = true

    if (!this.promoition_name) {
      return
    }
      try {
        let dataURL = this.apiURL + "Promotion/updatePromotion";
        let response = await axios.post(dataURL, this.promotionJson);
        if (response.data.status === "success") {
          this.showSuccess("Promotion Updated Successfully!");
          this.getAllPromotions();
          this.cancelSavePromotion();
        } else {
          this.showAlert("Error Happened Please Check Entered Data!");
        }
      } catch (error) {
        console.log(error);
      }
    },
    handleAddPromotion: async function () {
      this.showAddPromotion = true;
      this.promotionId = -1;
      this.promoition_name = "";
      this.start_date = "";
      this.end_date = "";
      this.minimum_total = "";
      this.percentage = "";
      this.promotionId = -1;
      this.useExcel = false;
      this.excelFile = null;
      this.excelFileName = "";
      this.excelItems = [];
      this.existingExcelUrl = "";
      this.existingExcelName = "";
      this.existingExcelInfo = "";

      this.showError = false;
      this.mainErrorMsg = "";
      this.showAddCustomer = true;
      this.toggle = false;
      try {
        if (this.$refs.fileInput) this.$refs.fileInput.value = "";
      } catch (e) {}
    },

    getCurrentDateTime() {
      let dateTimeStr = "";
      const nowDate = new Date();
      let year = nowDate.getFullYear();
      let month = nowDate.getMonth() + 1;
      let day = nowDate.getDate();
      var today = new Date();
      var time =
        today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
      dateTimeStr = year + "-" + month + "-" + day + " " + time;
      return dateTimeStr;
    },

    saveCustomer: async function () {
      //let customerJson = {};
      this.date_added = this.getCurrentDateTime();

      this.customerJson.appId = localStorage.appId;
      this.customerJson.name = this.name;
      this.customerJson.gender = this.gender;
      this.customerJson.email = this.email;
      this.customerJson.totalpoints = this.totalpoints;
      this.customerJson.phone = this.phone;
      this.customerJson.status = this.status;
      this.customerJson.creditstatus = this.creditstatus;
      this.customerJson.date_added = this.date_added;
      this.customerJson.created_by = localStorage.userId;
      this.customerJson.dis_percentage = this.dis_percentage;

      let addressJson = {};
      addressJson.addressLine1 = this.addressLine1;
      addressJson.addressLine2 = this.addressLine2;
      addressJson.addressArea = this.addressArea;
      addressJson.addressCity = this.addressCity;
      addressJson.isDefault =
        this.$el.querySelector("#default_address").checked;
      let addressArray = [];
      addressArray.push(addressJson);
      this.customerJson.addresses = addressArray;

      let customerJson_ = JSON.stringify(this.customerJson);
      try {
        let dataURL = this.apiURL + "Customers/createCustomer";

        let response = await axios.post(dataURL, customerJson_);
        if (response.data.status === "success") {
          this.customerInfos = response.data.results;
          this.toggle = true;
          this.showAddCustomer = false;
          this.name = "";
          this.gender = "";
          this.email = "";
          this.phone = "";
          this.dis_percentage = "";
          this.addressLine1 = "";
          this.addressLine2 = "";
          this.addressArea = "";
          this.addressCity = "";
          this.isDefault = false;
        }
      } catch (error) {
        console.log(error);
      }
    },

    getActivePromotions: async function () {
      this.promotionJson.appId = localStorage.appId;
      try {
        let dataURL = this.apiURL + "Promotion/getActivePromotions";
        let response = await axios.post(dataURL, this.promotionJson);
        if (response.data.status === "success") {
          this.promotions = response.data.results.promotions;
        }
      } catch (error) {
        console.log(error);
      }
      return this.promotions;
    },

    getAllPromotions: async function () {
      this.promotionJson.appId = localStorage.appId;
      try {
        let dataURL = this.apiURL + "Promotion/getAllPromotions";
        let response = await axios.post(dataURL, this.promotionJson);
        if (response.data.status === "success") {
          this.allPromotions = response.data.results.promotions;
        }
      } catch (error) {
        console.log(error);
      }
      return this.promotions;
    },
  },
};
</script>
<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: left;
  color: #2c3e50;
  margin-top: 20px;
}

.glyphicon.glyphicon-ok {
  font-size: 30px;
}

.button {
  font: bold 15px Arial;
  text-decoration: none;
  background-color: #eeeeee;
  color: #333333;
  /* padding: 2px 6px 2px 6px;
  border-top: 1px solid #cccccc;
  border-right: 1px solid #333333;
  border-bottom: 1px solid #333333;
  border-left: 1px solid #cccccc; */
}
.grid-container-element {
  display: grid;
  grid-template-columns: 5fr 1.5fr 1.5fr 1.5fr 0.5fr;
  grid-gap: 10px;
  border: 1px solid whitesmoke;
  border-left: 0px;
  border-right: 0px;
  border-top: 0px;
  width: 100%;
}
.grid-child-element_ {
  margin: 10px;
  border: 1px solid red;
}
.grid-child-element {
  margin: 2px;
  border-left: 0px;
  border-right: 0px;
  border-top: 0px;
  padding: 0 px;
}

.permission-card {
  display: flex;
  align-items: center;
  gap: 12px;
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
  padding: 1rem;
  border-radius: 10px;
  cursor: pointer;
  transition: all 0.3s ease;
  user-select: none;
}

.permission-card:hover {
  background: rgba(255, 255, 255, 0.08);
  border-color: rgba(255, 255, 255, 0.2);
  transform: translateY(-1px);
}

.permission-card.active {
  background: rgba(92, 107, 192, 0.2);
  border-color: var(--theme-primary);
  box-shadow: 0 4px 12px rgba(92, 107, 192, 0.15);
}

.custom-checkbox {
  width: 24px;
  height: 24px;
  border: 2px solid rgba(255, 255, 255, 0.4);
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  background: rgba(0,0,0,0.1);
  flex-shrink: 0;
}

.permission-card.active .custom-checkbox {
  background: var(--theme-primary);
  border-color: var(--theme-primary);
  transform: scale(1.05);
}

.checkmark {
  font-size: 14px;
  color: white;
  opacity: 0;
  transform: scale(0.5);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.permission-card.active .checkmark {
  opacity: 1;
  transform: scale(1);
}

.permission-card span {
  color: white;
  font-size: 1.2rem;
}
</style>
